import { render, staticRenderFns } from "./Prepack.vue?vue&type=template&id=12266a3e&"
import script from "./Prepack.vue?vue&type=script&lang=js&"
export * from "./Prepack.vue?vue&type=script&lang=js&"
import style0 from "./Prepack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports